import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
import { PagePreviewCarousel } from './PagePreviewCarousel';
const plan = {
  name: '📘 PROTOCOLLO ATLETA 360',
  ideal: 'Professionisti e atleti che desiderano gestire la riabilitazione con un metodo clinico visivo.',
  was: '54€',
  now: '27',
  features: ['6 Volumi Completi', 'Protocolli Spalla, Ginocchio, Caviglia, Schiena, Anca e Braccia', 'Quadri reali di "Return to Sport"', '5 Bonus Gratuiti inclusi', 'Garanzia di rimborso di 7 giorni', '♾️ Accesso a vita e aggiornamenti gratuiti'],
  cta: 'Ottieni il Metodo Atleta 360™ ora'
};
const trust = [{
  icon: LockIcon,
  label: 'Pagamento 100% sicuro'
}, {
  icon: ZapIcon,
  label: 'Accesso istantaneo'
}, {
  icon: CreditCardIcon,
  label: 'Credito / Debito'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Prezzo" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-131" data-mp="3w1jfy2f7wjyu">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-132" data-mp="9s8sr3datq96">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-133" data-mp="erldnikm0n94">
          <p className="font-display text-xl font-black text-plum" data-id="element-134" data-mp="eoz63ixpy7qw">🔥 Offerta limitata — Presto terminerà!</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-135" data-mp="3i81ycn63dhbg">
            ⚠️ Dopo, il prezzo tornerà a 54€. Questa tariffa non tornerà più.
          </p>
          <p className="mt-2 inline-flex rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold text-blush-deep" data-id="element-136" data-mp="3n5kaemfeocno">
            🎟️ Solo 12 posti rimasti a questo prezzo!
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 py-6 text-center shadow-[0_24px_60px_-28px_rgba(21,128,61,0.45)]" data-id="element-137" data-mp="2ugdb3l84nj1d">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-138" data-mp="2w8w8mpznd4z0">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-139" data-mp="28h7d70rj40du">
            <span className="font-semibold text-plum/80" data-id="element-140" data-mp="28jtu3r0b7s8q">Ideale per:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-141" data-mp="23la5fiuc02co">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-142" data-mp="2igpvzdvpdg4b">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-143" data-mp="2dgk888sk0dri">
              <span className="relative inline-block font-display leading-none" data-id="element-144" data-mp="2djg7c0g518hj">
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-145" data-mp="3ttij2bdjtge1">
                  {plan.now}
                </span>
                <span className="absolute left-full top-1/2 ml-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-146" data-mp="8sp8xh404jk">
                  €
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-147" data-mp="3rgf2nhtmrldm">
              · Pagamento unico · Accesso a vita ·
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-148" data-mp="j1eq5w6vilb0">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-149" data-mp="nzgbknrruwpn">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-150" data-mp="a7ibt3jyad65" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-151" data-mp="e7sdi40pmhf7">
            <CTAButton size="md" data-id="element-152" data-mp="11yxu4leh5dqk">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum" data-id="element-153" data-mp="16qzfcwtmeesq">
            Risparmi 141€ (84% di sconto)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-154" data-mp="3f8bjimm4vhvm">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-155" data-mp="35a44i9ben9w9">
                <Icon className="h-4 w-4 text-grape" data-id="element-156" data-mp="318iviz1zrfrc" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-157" data-mp="1s469lvniivu" />

        <PagePreviewCarousel data-id="element-158" data-mp="1ugj5kmjy321" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-159" data-mp="3syncenqjlknt">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-160" data-mp="3o6drxn875csx" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-161" data-mp="3k5tueijpo769">
            <span className="font-display font-bold text-plum" data-id="element-162" data-mp="kivcwfo97v6j">
              🛡️ Garanzia di Rimborso di 7 Giorni.
            </span>{' '}
            Se nei primi 7 giorni ritieni che il sistema non soddisfi le tue esigenze, chiedi il
            rimborso e ti restituiremo il 100% dei tuoi soldi. SIGMA SMART™ si impegna per i tuoi
            risultati.
          </p>
        </div>
      </div>
    </section>;
}